import {ref} from "vue";

const useAccountMissing = () => {
  const isAccountMissing = ref(false);

  const setIsAccountMissing = (value) => isAccountMissing.value = value;

  const checkResponseForAccountMissing = (response) => {
    if (response?.status === 404) {
      setIsAccountMissing(true);
    }
  };

  return {
    isAccountMissing,
    setIsAccountMissing,
    checkResponseForAccountMissing,
  };
};

export default useAccountMissing;